import {
  GET_SITE_CONFIG,
  GET_COUNTRIES,
  GET_SEARCH_CITY,
  GET_POPULAR_DESTINATIONS,
  GET_BIKE_TYPES,
  GET_EXTRA_ITEM_TYPES,
  POST_SUBSCRIPTION,
  DATA_SET_CURRENCY
} from '../constants';
import { lngs } from '../i18n';
import {
  defaultGetAction,
  defaultCreateAction
} from 'utils/redux';
import {
  capitalize,
  defaultTransform
} from 'utils';

export const loadCountries = () => ({
  type: GET_COUNTRIES,
  meta: {
    method: 'GET',
    endpoint: 'countries/',
    queryParams: {
      searchable: true
    }
  },
  i18n: {
    transform: (data) => {
      const resource = lngs.reduce((acc, lang) => ({
        ...acc,
        [lang]: {
          countries: {},
          cities: {}
        }
      }), {});

      data.forEach((country) => {
        lngs.forEach((lang) => {
          const nameKey = 'name' + capitalize(lang);
          const value = country[nameKey];

          if (value) {
            resource[lang].countries[country.nameEn] = value;
          }

          country.cities.forEach((city) => {
            const value = city[nameKey];

            if (value) {
              resource[lang].cities[city.nameEn] = value;
            }
          });
        });
      });

      return resource;
    }
  }
});

export const searchCity = (queryParams) => ({
  type: GET_SEARCH_CITY,
  meta: {
    method: 'GET',
    endpoint: 'cities/',
    queryParams
  },
  i18n: {
    transform: defaultTransform('cities', 'name')
  }
});

export const loadSiteConfig = () => ({
  type: GET_SITE_CONFIG,
  meta: {
    method: 'GET',
    endpoint: 'site/'
  },
  i18n: {
    transform: (data) => {
      const resource = lngs.reduce((acc, lang) => ({
        ...acc,
        [lang]: { meta: {} }
      }), {});

      ['title', 'description', 'keywords'].forEach(name => {
        lngs.forEach((lang) => {
          let key = `${name}${capitalize(lang)}`;

          if (name !== 'title') {
            key = `meta${capitalize(key)}`;
          }

          const value = data[key];

          if (value) {
            resource[lang].meta[name] = value;
          }
        });
      });

      return resource;
    }
  }
});

export const loadPopularDestinations =
  defaultGetAction(GET_POPULAR_DESTINATIONS, 'popular_destinations/');

export const loadBikeTypes = () => ({
  type: GET_BIKE_TYPES,
  meta: {
    method: 'GET',
    endpoint: 'bike_types/'
  },
  i18n: {
    transform: defaultTransform('bikeTypes', 'name')
  }
});

export const loadExtraItemTypes = () => ({
  type: GET_EXTRA_ITEM_TYPES,
  meta: {
    method: 'GET',
    endpoint: 'extra_item_types/'
  },
  i18n: {
    transform: defaultTransform('extraItemTypes', 'name')
  }
});

export const setCurrency = (value) => ({
  type: DATA_SET_CURRENCY,
  value
});

export const createSubscription = defaultCreateAction(POST_SUBSCRIPTION, 'subscriptions/');



// WEBPACK FOOTER //
// ./src/actions/app.js